'use strict';

/**
 * @ngdoc function
 * @name courseApp.controller:GroupController
 * @description
 * # GroupController
 * Controller of the courseApp
 */
angular.module('courseApp')
    .controller('GroupController', function ($scope, ActCourseService, BasicService, APIs, Utils, ConfigService) {
        var vm = this;
        vm.selectedGroup = undefined;
        vm.showAddGroup = false;
        vm.showEditGroup = false;
        vm.showDelGroup = false;

        vm.showDialog = function (dialog) {
            vm[dialog] = true;
        };

        vm.hideDialog = function (dialog) {
            vm[dialog] = false;
        };

        // load all groups of the course
        vm.loadGroupList = function () {
            vm.groupList = [];
            APIs.GroupService.query({ course: vm.selectedCourse.id }).$promise.then(function (data) {
                angular.forEach(data, function (attendee) {
                    vm.groupList.push(attendee);
                });
                vm.sortGroupList();
            });
        };

        // load all attendees of the course
        vm.loadAttendeeList = function () {
            vm.attendeeList = [];
            APIs.AttendeeService.query({ course: vm.selectedCourse.id }).$promise.then(function (data) {
                angular.forEach(data, function (attendee) {
                    vm.attendeeList.push(attendee);
                });
                vm.tableParamsAttendees.settings({
                    dataset: vm.attendeeList
                });
            });
        };

        vm.sortGroupList = function () {
            vm.groupList = BasicService.filter('orderBy')(vm.groupList, ['day', 'name']);
        };

        vm.addGroup = function (addGroup) {
            APIs.GroupService.save({ course: vm.selectedCourse.id, name: addGroup.name, day: addGroup.day }, function (data) {
                vm.groupList.push(data);
                vm.sortGroupList();
                vm.hideDialog('showAddGroup');
            });
        };

        vm.editGroup = function (editGroup) {
            var update = angular.copy(vm.selectedGroup);
            angular.forEach(editGroup, function (value, key) {
                update[key] = value;
            }, update);

            APIs.GroupService.update(update, function (data) {
                vm.groupList.splice(vm.groupList.indexOf(vm.selectedGroup), 1);
                vm.groupList.push(data);
                vm.sortGroupList();
                vm.hideDialog('showEditGroup');
            });
        };

        vm.delGroup = function () {
            APIs.GroupService.delete(vm.selectedGroup, function () {
                vm.groupList.splice(vm.groupList.indexOf(vm.selectedGroup), 1);
                vm.hideDialog('showDelGroup');
            });
        };

        // load all attendees of the selected group
        vm.loadGroupAttendeeList = function () {
            vm.groupAttendeeList = [];
            APIs.GroupAttendeeService.query({ group: vm.selectedGroup.id }).$promise.then(function (data) {
                angular.forEach(data, function (attendeeGroup) {
                    vm.attendee2Group(attendeeGroup.id, attendeeGroup.attendee, attendeeGroup.group);
                });
                vm.updateGroupAttendeList();
            });
        };

        vm.updateGroupAttendeList = function () {
            vm.tableParamsAttendeesGroup.settings({
                dataset: vm.groupAttendeeList
            });
        };

        vm.printGroupTeacher = function () {
            var pdfURL = ConfigService.CONFIG.backendURL + 'course/pdf/group/teacher/' + vm.selectedGroup.id + '/';
            Utils.savePDFFile(pdfURL, vm.selectedCourse.short_name + '_' + vm.selectedGroup.name + '_' + vm.date2String(vm.selectedGroup.day) + '.pdf');
            vm.hideDialog('printDialog');
        };

        vm.printGroupDisplay = function () {
            var pdfURL = ConfigService.CONFIG.backendURL + 'course/pdf/group/display/' + vm.selectedGroup.id + '/';
            Utils.savePDFFile(pdfURL, vm.selectedCourse.short_name + '_' + vm.selectedGroup.name + '_' + vm.date2String(vm.selectedGroup.day) + '.pdf');
            vm.hideDialog('printDialog');
        };

        vm.attendee2Group = function (id, attendeeId, groupId) {
            var a = BasicService.filter('filter')(vm.attendeeList, { id: attendeeId }, true);
            vm.groupAttendeeList.push({ id: id, attendee: a[0], group: groupId });
        };

        vm.add2Group = function (attendee) {
            APIs.GroupAttendeeService.save({ attendee: attendee.id, group: vm.selectedGroup.id }, function (data) {
                vm.attendee2Group(data.id, data.attendee, data.group);
                vm.updateGroupAttendeList();
                vm.tableParamsAttendees.filter({});
                var nameElements = BasicService.document[0].getElementsByName('person.name');
                if (nameElements.length >= 1) {
                    BasicService.timeout(function () {
                        nameElements[0].focus();
                    });
                }
            });
        };

        vm.removeFromGroup = function (ga) {
            APIs.GroupAttendeeService.delete(ga, function (data) {
                vm.groupAttendeeList.splice(vm.groupAttendeeList.indexOf(data), 1);
                vm.updateGroupAttendeList();
            });
        };

        // watch for changes on selectedGroup
        $scope.$watch(function () {
            return vm.selectedGroup;
        }, function () {
            if (angular.isDefined(vm.selectedGroup)) {
                vm.loadGroupAttendeeList();
            }
        });

        vm.colsAttendees = [
            { valueExpr: 'attendee.person.name', title: 'Name', sortable: 'person.name', filter: { 'person.name': 'text' }, show: true },
            { valueExpr: 'attendee.person.first_name', title: 'Vorname', sortable: 'person.first_name', filter: { 'person.first_name': 'text' }, show: true },
            { valueExpr: 'attendee.person.birthday | date:\'dd.MM.yyyy\'', title: 'GebDatum', show: true },
            { valueExpr: 'attendee.person.lizenz', title: 'Stufe', sortable: 'person.lizenz', filter: { 'person.lizenz': 'text' }, show: true },
            { valueExpr: 'attendee.type', title: 'Art', sortable: 'type', filter: { type: 'select' }, filterData: ConfigService.ATTENDEE_TYPE, show: true },
            { field: 'action', title: '', dataType: 'command' }
        ];

        vm.tableParamsAttendees = new ConfigService.NgTableParams({ page: 1, count: 10, sorting: { 'person.name': 'asc' } }, {
            counts: [10, 20, 30],
            defaultSelectValue: 'Show all',
            dataset: vm.attendeeList
        });

        vm.colsGroupAttendees = [
            { valueExpr: 'ga.attendee.person.name', title: 'Name', sortable: 'attendee.person.name', show: true },
            { valueExpr: 'ga.attendee.person.first_name', title: 'Vorname', sortable: 'attendee.person.first_name', show: true },
            { valueExpr: 'ga.attendee.person.birthday | date:\'dd.MM.yyyy\'', title: 'GebDatum', show: true },
            { valueExpr: 'ga.attendee.person.lizenz', title: 'Stufe', sortable: 'attendee.person.lizenz', show: true },
            {
                valueExpr: 'ga.attendee.type',
                show: false,
                groupable: 'type'
            },
            { field: 'action', title: '', dataType: 'command' }
        ];

        vm.tableParamsAttendeesGroup = new ConfigService.NgTableParams({ page: 1, count: 10, group: { 'attendee.type': 'asc' } }, {
            counts: [10, 20, 30],
            defaultSelectValue: 'Show all',
            dataset: vm.groupAttendeeList
        });

        vm.date2String = function (date) {
            return BasicService.filter('date')(date, 'yyyy-MM-dd');
        };

        vm.selectedCourse = ActCourseService.getActCourse();
        if (angular.isDefined(vm.selectedCourse)) {
            vm.courseBeginDate = vm.date2String(vm.selectedCourse.begin);
            vm.courseEndDate = vm.date2String(vm.selectedCourse.end);
            vm.loadGroupList();
            vm.loadAttendeeList();
        }
    });
